import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../../contexts/AppContext';
import divisionApi from '../../utils/api/division';
import { ActionButtons } from '../Shared/ActionButtons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FormModalWithContext } from '../Shared/form';
import { TextField } from '@mui/material';
import { ConfirmationModal } from '@stormwater-software/lib-ui';

const AreaSettings = () => {
  const [collapse, setCollapse] = useState(true);
  const [areasList, setAreasList] = useState<any[]>([]);
  const [isEdit, setIsEdit] = useState<any>();
  const [open, setOpen] = useState(false);
  const [newAreaName, setNewAreaName] = useState('');
  const [nameError, setNameError] = useState(false);
  const [showDeleteAreaModal, setShowDeleteAreaModal] = useState(false);
  const appContext = useContext(AppContext);
  const userTenantId =
    appContext &&
    appContext.state &&
    appContext.state.user &&
    appContext.state.user.tenantId;

  const loadInitialData = () => {
    divisionApi.areas.index().then((res) => {
      setAreasList(res);
    });
  };

  useEffect(() => {
    if (userTenantId) loadInitialData();
  }, [userTenantId]);

  const handleClose = () => {
    setOpen(false);
    setNewAreaName('');
    setNameError(false);
    setIsEdit(undefined);
  };

  const handleSave = (): Promise<void> => {
    if (newAreaName.trim() === '') {
      setNameError(true);
      return Promise.resolve();
    }
    divisionApi.areas
      .createNew(userTenantId, { name: newAreaName.trim() })
      .then((res) => {
        setAreasList([...areasList, res]);
        handleClose();
      });

    return Promise.resolve();
  };

  const handleEdit = (): Promise<void> => {
    if (newAreaName.trim() === '') {
      setNameError(true);
      return Promise.resolve();
    }
    divisionApi.areas
      .update(isEdit.id, { name: newAreaName.trim() })
      .then((res) => {
        setAreasList(
          areasList.map((ele) => {
            if (ele.id === isEdit.id) {
              return {
                ...ele,
                name: res.name,
              };
            }
            return ele;
          }),
        );
        handleClose();
      });

    return Promise.resolve();
  };

  const handleDelete = (): Promise<void> => {
    divisionApi.areas.destroy(userTenantId, [isEdit.id]).then(() => {
      setAreasList(areasList.filter((ele) => ele.id !== isEdit.id));
      setShowDeleteAreaModal(false);
      handleClose();
    });
    return Promise.resolve();
  };

  return (
    <div className='settings-tenant-main-container'>
      <div
        className='settings-main-tenant-text'
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          cursor: 'pointer',
        }}
        onClick={() => setCollapse(!collapse)}
      >
        <h3>Areas</h3>
        <i
          className={collapse ? 'fa fa-chevron-down' : 'fa fa-chevron-up'}
          aria-hidden='true'
        />
      </div>
      <hr></hr>
      <br />
      <div
        className={
          collapse ? 'administration-hidden' : 'administration-visible'
        }
      >
        <div className='admin-areas-table-body'>
          <h3>Name</h3>
          <h3>Edit</h3>
        </div>
        {areasList.map((area) => (
          <div className='admin-areas-table-body'>
            <h3>{area.name}</h3>
            <h3 className=''>
              <span
                onClick={() => {
                  setIsEdit(area);
                  setNewAreaName(area.name);
                  setOpen(true);
                }}
                style={{ cursor: 'pointer' }}
              >
                <FontAwesomeIcon icon={faEdit} title='Edit Area' />
              </span>
            </h3>
          </div>
        ))}
        <ActionButtons
          className='admin-areas-create-new-button'
          primary='Create New Area +'
          onClick={() => setOpen(true)}
        />
        <br />
        <br />
        <br />
      </div>
      {open && (
        <FormModalWithContext
          modalProps={{
            title: `${isEdit ? 'Edit Area' : 'Add Area'}`,
            submitBtnText: 'Submit',
          }}
          onSubmit={() => (isEdit ? handleEdit() : handleSave())}
          onCancel={handleClose}
          showDelete={isEdit ? true : false}
          onDelete={() => setShowDeleteAreaModal(true)}
        >
          <TextField
            autoFocus
            fullWidth
            label='Area Name'
            value={newAreaName}
            onChange={(e) => {
              setNewAreaName(e.target.value);
              setNameError(false);
            }}
            style={{ marginBottom: '20px' }}
            sx={{
              mb: 2,
              '& .MuiInputLabel-root': {
                color: '#002230',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#002230',
              },
              '& .MuiInputLabel-root.Mui-error': {
                color: '#FF4C51', // label in error
              },
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#002230',
                },
                '&:hover fieldset': {
                  borderColor: '#002230',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#002230',
                },
                '&.Mui-error fieldset': {
                  borderColor: '#FF4C51', // outline in error
                },
              },
              '& .MuiInputBase-input': {
                color: '#002230', // input text color
              },
              '& .MuiFormHelperText-root.Mui-error': {
                color: '#FF4C51', // helper text in error
              },
            }}
            error={nameError}
            helperText={nameError ? 'Name cannot be empty' : ''}
          />
        </FormModalWithContext>
      )}

      <ConfirmationModal
        show={showDeleteAreaModal}
        handleConfirm={handleDelete}
        handleClose={() => setShowDeleteAreaModal(false)}
        title='Delete Area'
        subTitle='Are you sure you want to delete this area? All linked projects will be unassociated.'
        buttonText='Delete Area'
      />
    </div>
  );
};
export default AreaSettings;
